import { render, staticRenderFns } from "./UpdateProductStockStatusModal.vue?vue&type=template&id=abcf8768&scoped=true"
import script from "./UpdateProductStockStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateProductStockStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcf8768",
  null
  
)

export default component.exports